import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import AppHeader from "components/shared/AppHeader";
import AppFooter from "components/shared/AppFooter";
import { useAuth } from "provider/AuthContext";

const DashboardLayout = () => {
  const { user, logout } = useAuth();
  const [isMobile, setIsMobile] = useState(window?.innerWidth <= 991);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 991);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    if (isMobile) {
      setIsSidebarOpen(false);
    } else {
      setIsSidebarOpen(true);
    }
  }, [isMobile]);

  return (
    <div className="flex flex-col">
      <AppHeader toggleSidebar={setIsSidebarOpen} isSidebarOpen={isSidebarOpen} />

      {/* Sidebar and main content */}

      <div className="lg:p-5 p-2 md:p-0 flex flex-col lg:flex-row w-full flex-1">
        {/* Sidebar can be toggled */}
        <Sidebar user={user} logout={logout} isSidebarOpen={isSidebarOpen} toggleSidebar={setIsSidebarOpen} />

        {/* Main content */}
        <div className="flex-1 lg:p-[1.5rem] p-3 bg-[#fff] rounded-lg md:rounded-none lg:rounded-tr-lg lg:rounded-br-lg ltr:lg:rounded-r-xl ltr:lg:rounded-l-none rtl:lg:rounded-l-xl rtl:lg:rounded-r-none">
          <Outlet />
        </div>
      </div>
      <AppFooter />
    </div>
  );
};

export default DashboardLayout;
